/**
 * Common headers to be sent with every HTTP request
 */
export const ClientApplicationHttpHeaders = {
  'x-application-id': 'templates-ui',
};
